import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import UnidadeExecutoraForm from "../../../components/forms/UnidadeExecutoraForm.vue";
import { UnidadeExecutoraService } from "../../../services/UnidadeExecutoraService";

export default {
  name: "CriarUnidadeExecutora",
  components: {
    Breadcrumb,
    UnidadeExecutoraForm
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "Página Inicial",
          disabled: false,
          href: "/"
        },
        {
          text: "Gerenciamento de Unidades Executoras",
          disabled: false,
          href: "/gerenciar-unidades-executoras"
        },
        {
          text: "Cadastrar Unidade Executora",
          disabled: true,
          href: "/unidades-executoras/criar"
        }
      ]
    };
  },
  methods: {
    async handleSave(formData) {
      try {
        // Criar FormData seguindo o padrão existente
        const postData = new FormData();
        
        postData.append("exercicio", formData.exercicio);
        postData.append("codigo_unidade", formData.codigo_unidade);
        postData.append("nome", formData.nome);
        postData.append("ativo", formData.ativo ? 1 : 0);
        
        const response = await UnidadeExecutoraService.store(postData);
        
        if (response) {
          // Redirecionar para a lista de Unidades Executoras após salvar
          this.$router.push('/gerenciar-unidades-executoras');
        } else {
          throw new Error('Erro ao criar Unidade Executora');
        }
      } catch (error) {
        console.error('Erro ao criar Unidade Executora:', error);
        // O componente UnidadeExecutoraForm já trata a exibição de mensagens de erro
        throw error;
      }
    },
    handleCancel() {
      // Retornar para a tela principal do menu
      this.$router.push('/gerenciar-unidades-executoras');
    }
  }
};
